/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 查看更多
 */
"use strict";
angular.module("lookMoreModule", []).
controller("lookMoreCtrl", ["$scope", "modalDialog", "$modalInstance", "httpService", "roleId", function($scope, modalDialog, $modalInstance, httpService, roleId) {
    initStatus();
    initData();

    function initStatus() {
        $scope.status = {

        };
        $scope.statusList = [];
        $scope.data = {
            roleId: roleId,
        }
        $scope.articleStatus = {
            0: '草稿',
            1: '待审核',
            2: '二次审核',
            3: '已签发',
            4: '已退稿'
        };
        $scope.colorStatus = {
            0: 'yellow',
            1: 'orange',
            2: 'audit',
            3: 'green',
            4: 'red'
        };
    }

    function initData() {
        requestData();
    }
    $scope.confirm = function() {
        $modalInstance.close($scope.data);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    function requestData() {
        var statusList = $scope.data.roleId.statusList;

        for (var i = 0; i < statusList.length; i++) {
            var newJson = {};
            newJson.name = statusList[i].articleStatus;
            newJson.value = statusList[i].channelName;
            $scope.statusList.push(newJson);
        }

    }
    /**
     * [fullTextSearch description;]
     * @param  {[type]} ev [description:按下回车也能提交]
     */

}]);
